import { useState, useEffect, useCallback } from "react";

/**
 * Custom hook for search with debouncing
 * @param {number} delay - Debounce delay in milliseconds (default: 300)
 * @returns {Object} Search state and handlers
 */
export const useSearch = (delay = 300) => {
    const [searchText, setSearchText] = useState("");
    const [debouncedSearchText, setDebouncedSearchText] = useState("");

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearchText(searchText);
        }, delay);

        return () => clearTimeout(timer);
    }, [searchText, delay]);

    const handleSearchChange = useCallback((value) => {
        setSearchText(value);
    }, []);

    const clearSearch = useCallback(() => {
        setSearchText("");
        setDebouncedSearchText("");
    }, []);

    return {
        searchText,
        debouncedSearchText,
        setSearchText: handleSearchChange,
        clearSearch
    };
};

